import clsx from 'clsx';
import React from 'react';
export const FloatingFormInput = React.forwardRef(function FloatingFormInput(props, ref) {
    const { className, type = 'text', ...rest } = props;
    return (React.createElement("input", { type: type, className: clsx('border border-app-gray-line rounded-lg p-1 text-lg pt-5 pb-3 px-6 block w-full peer', className), ...rest, ref: ref }));
});
